import { divisionIdFromCardTarget, shouldSyncStandingsOnHover } from './divisionStandingsHover.js';

export type DivisionStandingsHoverTarget = {
  selectDivision: (divisionId: number) => void;
  getSelectedDivision: () => number;
};

/** Hover d’une carte division → bascule l’onglet classement correspondant. */
export function bindDivisionCardStandingsHover(
  cardsHost: HTMLElement,
  standings: DivisionStandingsHoverTarget
): () => void {
  const onEnter = (event: Event): void => {
    const division = divisionIdFromCardTarget(event.target);
    if (!shouldSyncStandingsOnHover(standings.getSelectedDivision(), division)) return;
    standings.selectDivision(division);
    highlightDivisionCard(cardsHost, division);
  };

  cardsHost.addEventListener('mouseover', onEnter);
  highlightDivisionCard(cardsHost, standings.getSelectedDivision());

  return () => {
    cardsHost.removeEventListener('mouseover', onEnter);
    cardsHost
      .querySelectorAll('.championship-division-card.is-standings-focus')
      .forEach((el) => el.classList.remove('is-standings-focus'));
  };
}

export function highlightDivisionCard(cardsHost: HTMLElement, division: number | null): void {
  cardsHost.querySelectorAll<HTMLElement>('.championship-division-card').forEach((card) => {
    const id = Number(card.dataset.division);
    card.classList.toggle('is-standings-focus', division != null && id === division);
  });
}
